<p class="pb-2">{{ 'description' | translate }}</p>
<div #editor class="editor-container"></div>
<div *ngIf="valid" class="alert">
  {{ 'invalid.input' | translate }}
</div>
